import LightMark from "../assets/slip-mark-light.svg";
import DarkMark from "../assets/slip-mark-dark.svg";
import { useTheme } from "../theme";

/** The Slip mark: navy front panel on light, ivory front panel on charcoal (brand kit). */
export default function BrandMark({ className = "h-10 w-10 shrink-0 object-contain", alt = "TryOn AI" }) {
    const { resolvedTheme } = useTheme();
    return <img src={resolvedTheme === "dark" ? DarkMark : LightMark} alt={alt} className={className} />;
}
